import { Drivers } from "modules/drivers";

const DriversPage = () => {
  return <Drivers />;
};

export default DriversPage;
